// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__3NyrJ","container":"LayoutSideNavigation_container__TMpQv","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__1Bjyg"};